module.exports = __webpack_public_path__ + "static/media/megaphone-alt.e53fbfba.svg";